// Cuentas de destino según el switch (Mario, 30-oct): por defecto se ven las de la empresa activa; los chips permiten
// ver las otras. El núcleo manda `perfil_activo` con cada cuenta (?perfil_activo=1); sin él, todo como antes.
const esCT = (v: any) => String(v ?? '').trim().toUpperCase() === 'CT';
const esMT = (v: any) => String(v ?? '').trim().toUpperCase() === 'MT';

// Misma regla que empresaDeCuenta (pipes/empresa-cuenta.pipe): CT si perfil o empresa es 'CT'
const empresaDe = (c: any) => (esCT(c?.perfil) || esCT(c?.empresa) ? 'CrediTotal' : 'Mundo Total');

/** Filtro inicial: la empresa del switch ('CrediTotal' | 'Mundo Total'), o 'Todas' si no vino el perfil. */
export const empresaActiva = (cuentas: any[]): 'CrediTotal' | 'Mundo Total' | 'Todas' => {
  const c = (cuentas || []).find((x: any) => esCT(x?.perfil_activo) || esMT(x?.perfil_activo));
  return !c ? 'Todas' : esCT(c.perfil_activo) ? 'CrediTotal' : 'Mundo Total';
};

/** Copia con las cuentas de la empresa activa primero; dentro de cada grupo, el orden que traían. */
export const activasPrimero = (cuentas: any[], empresa: string) => {
  const lista = [...(cuentas || [])];
  if (empresa !== 'CrediTotal' && empresa !== 'Mundo Total') return lista;
  return [...lista.filter((c: any) => empresaDe(c) === empresa), ...lista.filter((c: any) => empresaDe(c) !== empresa)];
};
